import { useConfirm } from "@/platform/ui/patterns/ConfirmProvider.js";

/** The "Discard changes?" confirmation EntityFormModal wraps every close path
 *  with, factored out so a non-modal body using useEntityForm alone (an inline
 *  editor, a table's edit mode) gets the same guarantee instead of a bespoke copy.
 *  `target` is the full phrase, e.g. "this task", "these entries". Resolves
 *  true once the form has closed, unchanged or discarded, and false when the
 *  person keeps editing — so a host closing around the form knows whether to. */
export function useConfirmedClose(
  requestClose: () => boolean,
  discard: () => void,
  target: string,
): () => Promise<boolean> {
  const confirm = useConfirm();
  return async () => {
    if (requestClose()) return true;
    const ok = await confirm({
      title: "Discard changes",
      message: `Discard the changes to ${target}?`,
      confirmLabel: "Discard",
    });
    if (ok) discard();
    return ok;
  };
}
